import React from 'react';
import { Badge } from 'native-base';

export function Example() {
  return <Badge>NEW FEATURE</Badge>;
}
